import { motion } from "framer-motion";
import SectionLabel from "../components/SectionLabel";
import { TESTIMONIALS } from "../data/site";

function Quote({ t }) {
  const words = t.quote.split(" ");
  const accents = (t.accent || []).map((a) => a.toLowerCase());
  const isAccent = (w) => accents.includes(w.toLowerCase());

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
      className="grid grid-cols-1 gap-6 border-t border-white/[0.08] py-16 md:grid-cols-[auto_1fr] md:gap-16 md:py-24"
    >
      <span className="text-lav-400 text-6xl md:text-8xl leading-[0.6] thin select-none">
        “
      </span>
      <div>
        <p className="text-big uppercase leading-[1.05] max-w-5xl text-white">
          {words.map((w, k) => (
            <span key={k} className={isAccent(w) ? "text-lav-400" : "text-white"}>
              {w}
              {k < words.length - 1 ? " " : ""}
            </span>
          ))}
        </p>
        <div className="mt-10 flex items-center gap-4">
          <span className="h-px w-10 bg-lav-400" />
          <span className="label text-white">{t.name}</span>
          <span className="label text-white/40">{t.role}</span>
        </div>
      </div>
    </motion.div>
  );
}

export default function Testimonials() {
  return (
    <section className="px-6 md:px-12 lg:px-16 py-32 md:py-48" data-testid="testimonials">
      <SectionLabel index="08">WHAT THEY SAY</SectionLabel>
      <div className="mt-12">
        {TESTIMONIALS.map((t) => (
          <Quote key={t.name} t={t} />
        ))}
      </div>
    </section>
  );
}
